export default __webpack_public_path__ + "static/media/health.bdfc61db.svg";